import * as Constants from '@/store/constants'

import axios from 'axios'

import Survey from '@/api/services/survey'

export const http = () => {
  // this.$loading(true)
  let requester = axios.create({
    'baseURL': Constants.API_BASEURL,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json'
      // 'Authorization': 'Token ' + Constants.API_KEY
    }
  })
  requester.interceptors.response.use((response) => {
    // this.$loading(false)
    return Promise.resolve(response)
  }, (error) => {
    // this.$loading(false)
    return error
  })
  return requester
}

export default {
  http,
  Survey
}
